// Which new chat message, if any, should pop up as a preview while the chat is closed.
//
// `messages` is one phase's messages, oldest first. `seen` is what the last call
// returned ({ phase, lastId }), so a message is only ever previewed once and
// whatever was already in the chat when the player arrived (or the phase
// changed) stays quiet.

export const PEEK_CHARS = 90;

export function findPeek({ messages, phase, seen, currentUserId, canPeek }) {
  const lastId = messages.length ? messages[messages.length - 1].id : null;
  const next = { phase, lastId };

  // First look at this phase: remember where it is without previewing the backlog.
  if (!seen || seen.phase !== phase) return { peek: null, seen: next };
  if (lastId === seen.lastId) return { peek: null, seen };

  const from = seen.lastId == null ? 0 : messages.findIndex((m) => m.id === seen.lastId) + 1;
  // The last message we saw is gone (trimmed): resync rather than guess.
  if (seen.lastId != null && from === 0) return { peek: null, seen: next };

  let peek = null;
  if (canPeek) {
    for (const m of messages.slice(from)) {
      if (m.type !== 'chat' && m.type !== undefined) continue;
      if (m.userId === currentUserId) continue;
      if (!m.content || !String(m.content).trim()) continue;
      peek = {
        id: m.id,
        name: m.playerName || 'Someone',
        text: String(m.content).replace(/\s+/g, ' ').trim().slice(0, PEEK_CHARS),
      };
    }
  }
  return { peek, seen: next };
}
